//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SubscriptionClient from "../../../../clients/robox-api/SubscriptionClient";

import moneyFormat from '../../../../util/moneyFormat.js';

export default  {
    name: 'MySubscriptionsAllOrdersModal',
    props: {
        subscription: {
            required: true,
            type: Object,
        },
    },
    data: () => {
        return {
            purchases: [],
        };
    },
    computed: {
    },
    filters: {
        formattedMoney: function (amount) {
            return moneyFormat(amount);
        },
    },
    methods: {
    },
    created () {
        new SubscriptionClient()
            .purchases(this.subscription.attributes.id)
            .then((response) => {
                this.purchases = response.data;
            });
    },
    mounted () {
    },
};




// WEBPACK FOOTER //
// ./scripts/vue/components/template-dashboard/my-subscriptions/MySubscriptionsAllOrdersModal.vue